export default "__VITE_ASSET__BL79vdNF__"